import React, { useEffect, useState } from "react";
import NewsCard from "./NewsCard";
import axios from "axios";
import { useContext } from "react";
import { UserContext } from "../context/UserContext";
import { Link } from "react-router-dom";

export default function FreeOddSection({ title, header }) {
  const [leagues, setLeagues] = useState([]);
  const { news } = useContext(UserContext);
  const [bet, setBet] = useState({});
  const randomNews = Math.floor(Math.random() * news.length);

  useEffect(() => {
    axios
      .get(`/bet/${title}`)
      .then(({ data }) => {
        setBet(data);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get("/league")
      .then(({ data }) => {
        setLeagues(data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [title]);

  const leagueElements = leagues.map((league) => (
    <li key={league._id}>{league.titleShort}</li>
  ));

  console.log(bet);

  const betElement = bet.betList?.map((bet, index) => (
    <tr key={index}>
      <td>{index + 1}</td>
      <td>{bet.country.long}</td>
      <td>
        {bet.teams.home.long} vs {bet.teams.away.long}
      </td>
      <td>{bet.tip.long}</td>
      <td>{bet.time}</td>
    </tr>
  ));

  const btnElements = bet.betRefUrl?.map((bet) => (
    <Link to={bet.url} key={bet.type}>
      <button
        className="ref_btn"
        style={
          bet.type[0] === "S"
            ? { color: "white", backgroundColor: "red" }
            : bet.type[0] === "B"
            ? { color: "white", backgroundColor: "black" }
            : { color: "white", backgroundColor: "black" }
        }
      >
        {bet.type}
      </button>
    </Link>
  ));

  return (
    <section className="free_section">
      <h2>{header}</h2>
      {bet.betList === undefined ? (
        <div
          style={{
            backgroundColor: "rgba(65, 63, 63, 1)",
            margin: "0 1rem",
            borderRadius: "8px",
            padding: "1rem",
            color: "white",
            textAlign: "center",
          }}
        >
          <h3
            style={{
              color: "#ec642b",
            }}
          >
            Predictions Coming Soon
          </h3>
          <p
            style={{
              maxWidth: 800,
              margin: "0 auto",
            }}
          >
            Our expert analysts are currently analyzing matches to provide you
            with the most accurate predictions. Please check back in a few
            moments.
          </p>
        </div>
      ) : (
        <div className="free_bet_section_container">
          <div className="free_bet_container">
            <h4>{bet.odds}+ odds </h4>
            <div className="bet_list_container">
              <table className="free_daily_bet">
                <thead>
                  <tr>
                    <th></th>
                    <th>League</th>
                    <th>Team</th>
                    <th>Tips</th>
                    <th>Time</th>
                  </tr>
                </thead>

                <tbody>{betElement}</tbody>
              </table>

              <div className="ref_btn_container">{btnElements}</div>
            </div>
          </div>

          <div className="free_section_left">
            <div className="leagues">
              <h4 style={{ color: "#ec642b" }}>Football Leagues</h4>
              <ul>{leagueElements}</ul>
            </div>

            <NewsCard news={news[randomNews]} />
          </div>
        </div>
      )}
    </section>
  );
}
